import { TextEllipsis } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
import './FullCellButton.css';
const FullCellButton = ({ className, disabled = false, onClick, text, }) => (React.createElement("button", { className: `${className !== undefined ? `${className} ` : ''}co-full-cell-button`, disabled: disabled, onClick: onClick, type: "button" },
    React.createElement(TextEllipsis, { tooltipProps: { type: "hint" } }, text)));
export default FullCellButton;
